/** @type {string} */
export const CONTACT_CONSENT_WORDING_VERSION = '2026-06-v1';

/** @type {readonly string[]} */
export const CONTACT_ROLE_OPTIONS = [
  'parent',
  'pacExecutive',
  'schoolStaff',
  'other',
];

/** @type {readonly string[]} */
export const CONTACT_INTEREST_OPTIONS = ['pilotSchool', 'demo', 'general'];
